<template>
    <div class="step bugget-range">
        <AdvTitle class="mb-4">{{$t("common:signLog.adv.budgetRangeTitle")}}</AdvTitle>
        <AdvSubTitle>{{ $t("common:signLog.adv.budgetRangeSubtitle") }}</AdvSubTitle>
        <AdvRange
            class="mb-40"
            v-bind="rangeConfig"
            @change="handleRangeChange"
        ></AdvRange>
        <AdvBtn @click="handleNext">{{ $t("common:signLog.adv.budgetRangeBtnText") }}</AdvBtn>
    </div>
</template>
<script>
import AdvBtn from './components/btn.vue';
import AdvRange from './components/range.vue';
import AdvSubTitle from './components/subTitle.vue';
import AdvTitle from './components/title.vue';
export default {
    inject: ['next', 'progress'],
    data: function() {
        return {
            rangeConfig: {
                showTips: false,
                unit: '$',
                fixed: 0,
                ticks: [
                    100000, 200000, 350000, 500000, 800000, 1500000, 3000000,
                    4000000
                ],
                defaultValue: [200000, 800000]
            },
            mobileRangeConfig: [
                {
                    label: 'Under $400K',
                    value: [0, 400000]
                },
                {
                    label: '$400K - $700K',
                    value: [400001, 700000]
                },
                {
                    label: '$700K - $1M',
                    value: [700001, 1000000]
                },
                {
                    label: '$1M or more',
                    value: [1000001, -1] // The case of no upper limit is waiting for the backend to determine
                }
            ]
        };
    },
    methods: {
        handleNext() {
            this.next(
                {
                    budgeRangeMin: this.range[0],
                    budgeRangeMax: this.range[1]
                },
                'questionAnswer'
            );
        },
        handleRangeChange(range) {
            console.log(range);
            this.range = range;
        }
    },
    components: {
        AdvBtn,
        AdvRange,
        AdvSubTitle,
        AdvTitle
    }
};
</script>
<style lang="scss">
.bugget-range {
    .range-list {
        .adv-btn.block {
            margin-top: 10px;
            background: rgba(76, 132, 255, 0.12);
            color: #4c84ff;
            font-size: 16px;
            font-family: var(--font-bold);
            border-radius: 24px;
            height: 48px;
            line-height: 48px;
            &:first-child {
                margin-top: 0px;
            }
            &:active {
                background-color: #4c84ff;
                color: #fff;
            }
        }
        border: 0;
        padding: 0;
    }
}
</style>
